import React from 'react';

import useParentModalCid from 'ui-library/hooks/useParentModalCid';
import {DatetimePickerContext} from 'ui-library/inputs/DatetimePicker';
import {DateAndDatetimeBaseProps} from 'ui-library/inputs/InputConstants';

/**
 * Wrapper component to properly render `DatetimePicker`s in structured tables.
 */
export default function StructuredTableDatetimeInputContainer<P extends DateAndDatetimeBaseProps>(props: {
  children: React.ReactElement<P>;
}): JSX.Element {
  const {containerNodeSelector} = DatetimePickerContext.useContext();
  const [parentModalCid, datetimePickerRef] = useParentModalCid();

  const newProps: Partial<DateAndDatetimeBaseProps> = {
    datePickerPopperContainerSelector:
      parentModalCid != null ? `[data-modal-cid="${parentModalCid}"]` : containerNodeSelector,
    // Ensure table cell isn't auto-dismissed on click
    // See: client/notebook/mediocre/selection/block/MultiSelectListUtil.ts
    wrapperClassName: 'js-mediocre-active-edit',
    datetimePickerRef,
  };
  return <>{React.cloneElement(props.children, newProps)}</>;
}
